import { render, staticRenderFns } from "./usekshow.vue?vue&type=template&id=9386a95c"
import script from "./usekshow.vue?vue&type=script&lang=js"
export * from "./usekshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports